(function () {
  var api = window.NCStackedIntro || {};

  function setExpanded(root, expanded) {
    var expandedContent = root.querySelector("[data-nc-stacked-intro-expanded]");
    var toggle = root.querySelector("[data-nc-stacked-intro-toggle]");

    if (!expandedContent || !toggle) return;

    expandedContent.classList.toggle("nc-stacked-intro__expanded--open", expanded);
    toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
    toggle.textContent = expanded
      ? toggle.getAttribute("data-show-less-label") || "Show Less"
      : toggle.getAttribute("data-read-more-label") || "Read More";
  }

  function resetRoot(root) {
    if (!root || !root.ncStackedIntroState) return;

    var toggle = root.querySelector("[data-nc-stacked-intro-toggle]");
    if (toggle) {
      toggle.removeEventListener("click", root.ncStackedIntroState.onToggle);
    }

    setExpanded(root, false);
    delete root.ncStackedIntroState;
    delete root.dataset.ncStackedIntroInitialized;
  }

  function initRoot(root) {
    if (!root || root.dataset.ncStackedIntroInitialized === "true") return;

    var toggle = root.querySelector("[data-nc-stacked-intro-toggle]");
    var expandedContent = root.querySelector("[data-nc-stacked-intro-expanded]");

    if (!toggle || !expandedContent) return;

    var state = {
      isExpanded: false,
      onToggle: function () {
        state.isExpanded = !state.isExpanded;
        setExpanded(root, state.isExpanded);
      }
    };

    toggle.addEventListener("click", state.onToggle);
    root.ncStackedIntroState = state;
    root.dataset.ncStackedIntroInitialized = "true";
    setExpanded(root, false);
  }

  function initAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-stacked-intro]")
      : [];

    if (scope.matches && scope.matches("[data-nc-stacked-intro]")) {
      initRoot(scope);
    }

    roots.forEach(initRoot);
  }

  function resetAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-stacked-intro]")
      : [];

    if (scope.matches && scope.matches("[data-nc-stacked-intro]")) {
      resetRoot(scope);
    }

    roots.forEach(resetRoot);
  }

  api.initAll = initAll;
  api.resetAll = resetAll;
  window.NCStackedIntro = api;

  if (!window.__ncStackedIntroEventsBound) {
    window.__ncStackedIntroEventsBound = true;

    document.addEventListener("DOMContentLoaded", function () {
      window.NCStackedIntro.initAll(document);
    });

    document.addEventListener("shopify:section:load", function () {
      window.NCStackedIntro.resetAll(document);
      window.NCStackedIntro.initAll(document);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      window.NCStackedIntro.resetAll(event.target);
    });
  }

  if (document.readyState !== "loading") {
    window.NCStackedIntro.initAll(document);
  }
})();
